import { get, post, put, httpDelete, urlConfig } from '../utils/request'
import qs from 'qs'
import node_env from "../node_env";

let apiUrl = 'https://11-app-mop.smartz.cloud'//'https://11-app-mop.meshare.cn';
if(node_env === 'production'){
  apiUrl = 'https://11-app-mop.smartz.cloud'
}

let urlApp = '/app'

export function login(data) {
  const url = `${apiUrl}/user/login?email=${data.email}&password=${data.password}&cid=${data.cid}&platform=${data.platform}&client=${data.client}&language=${data.language}`
  return get(url, {})
}

export function loginV5(data) {
  const url = `${apiUrl}/user/user_login`;
  let headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }
  return post(url, qs.stringify(data), headers)
}

export function logoutUser(data) {
  const url = `${apiUrl}/user/logout`;
  let headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }
  return post(url, qs.stringify(data), headers)
}


export function getChangePassword(data) {
  const url = `${urlApp}/user/modify_passwd`;
  let headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }
  return post(url, qs.stringify(data), headers)
}


export function tryRegister(data) {
  const url = `${apiUrl}/user/try_register`;
  let headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }
  return post(url, qs.stringify(data), headers)
}

export function activateEmail(data) {
  const url = `${apiUrl}/user/activate_email`;
  let headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }
  return post(url, qs.stringify(data), headers)
}

export function sendVerification(data) {
  const url = `${apiUrl}/user/send_verification`;
  let headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }
  return post(url, qs.stringify(data), headers)
}

export function sendEmailCode(data) {
  const url = `${apiUrl}/user/forget_passwd`;
  let headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }
  return post(url, qs.stringify(data), headers)
}

export function resetPassword(data) {
  const url = `${apiUrl}/user/reset_passwd`;
  let headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  }
  return post(url, qs.stringify(data), headers)
}



// WEBPACK FOOTER //
// ./src/api/user.js